import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo12U3Act11 from "../../../DnD/modulo12U3Act11";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[11];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[10].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[10].path}`,
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[12].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[12].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const items = [
    <div className="selectable btn btn-red shadow mx-3 my-1">valiente</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">fuerte</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">responsable</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">cariñoso(a)</div>,
    <div className="selectable btn btn-red shadow mx-3 my-1">inteligente</div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mb-4">
            <li>
              Muchas veces creemos que solo los hombres pueden ser fuertes o
              solo las mujeres pueden ser cariñosas. Esos son prejuicios, o sea,
              ideas que no reflejan la realidad.
            </li>
            <li>
              Observa a estos personajes. Arrastra las palabras que correspondan
              a cada personaje. Recuerda que una misma característica puede ser
              compartida por hombres y mujeres.
            </li>
          </ul>
        </div>
      </div>
      <Modulo12U3Act11 items={items} />

      <GuiaDocente>
        <ul>
          <li>
            Explique que las actividades siguientes buscan mostrar algunos
            prejuicios que son frecuentes con respecto a los hombres y a las
            mujeres. Luego, se elaborará una propuesta que busca luchar contra
            esos prejuicios.
          </li>
          <li>
            Lea la primera indicación: Muchas veces creemos que solo los hombres
            pueden ser fuertes o solo las mujeres pueden ser cariñosas. Esos son
            prejuicios, o sea, ideas que no reflejan la realidad. Pregunte si han escuchado la palabra “prejuicio” antes. Si no la
            han escuchado, pueden buscarla en el diccionario. De no contar con
            un diccionario, lea usted la definición:
            <ul>
              <li>
                <i>
                  “Acción y efecto de prejuzgar. Opinión previa y tenaz, por lo
                  general desfavorable, acerca de algo que se conoce mal”
                  (Diccionario de la Real Academia de la lengua española).
                </i>
              </li>
            </ul>
          </li>

          <li>
            Explique la definición y pregunte qué otros prejuicios sobre hombres
            y mujeres conocen. Lea la segunda indicación: Observa estos
            personajes. Arrastra las palabras que correspondan a cada personaje.
            Recuerda que una misma característica puede ser compartida por
            hombres y mujeres. Recuerda que una misma característica puede ser
            compartida por hombres y mujeres. Pida que lean en silencio los
            párrafos ubicados debajo de cada imagen y que relacionen cada
            personaje con las palabras que aparecen arriba.
          </li>
          <li>
            Pregunte por las respuestas, para ello: - Pida a un niño o una niña
            que lea en voz alta el párrafo sobre Pepe Murakami ubicado al
            costado de la primera imagen. - Pregunte con qué características
            puede relacionar la imagen y por qué. - Haga lo mismo con la segunda
            imagen. - A Pepe se le podría asociar con las características de
            fuerte, responsable y cariñoso, por ejemplo; a Eli con las de
            valiente, fuerte, responsable e inteligente.
          </li>
          <li>
            Cierre la actividad retomando las ideas presentadas al inicio. Por
            ejemplo, puede comentar lo siguiente:
            <ul>
              <li>
                <i>
                  “Hay algunas creencias que relacionan algunas características
                  con hombres y otras con mujeres. Por ejemplo, se cree que la
                  valentía y la fortaleza son características masculinas. Pero
                  sabemos que las mujeres también presentan en diversas
                  situaciones estas características. Por lo tanto, asociar
                  ciertas características solo a hombres o solo a mujeres
                  resulta ser un “prejuicio”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
